<template>
  <section class="hero">
      <div class="hero__content container">
        <div class="hero__content--info">
          <h1 class="hero__title">
              Thank You for Joining the <br> Sequire Investor Summit 2023
          </h1>
          <p class="hero__description">
            We would like to extend our heartfelt gratitude for your interest and support in the recently concluded Sequire Investor Summit 2023. 
          </p>
          <p class="hero__description">
            As we continue to grow and expand, we want to invite you to stay engaged with us through our upcoming virtual events, and we look forward to hosting more live Sequire Investor Summits next year. 
          </p>
          <p class="hero__description">
            We will keep you updated on all upcoming events, so please stay tuned.
          </p>
        </div>
        <!--<iframe 
          class="hero__content--video"
          width="520" 
          height="247" 
          src="https://www.youtube.com/embed/dL-kbbArE6M" 
          title="YouTube video player" 
          frameborder="0" 
          allow="accelerometer; 
          autoplay; 
          clipboard-write; 
          encrypted-media; 
          gyroscope; 
          picture-in-picture" 
          allowfullscreen>
        </iframe> -->
      </div>
    </section>
  </template>
  
  <script>

  export default {
    name: 'Hero',
    data () {
      return {
      }
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
  @import "../styles/components/hero.scss";
  </style>
  